<div class="timekeeping-settings-panel layout-column" appBringozIdGenerator="timekeeping-settings-panel">

  <div class="flex layout-column overflow-auto">

    <!--Table Columns-->
    <section class="table-settings-header">
      <div class="layout-row layout-align-start-center padding-10">
        <span class="flex br-body-2 font-weight-600">{{ 'Table Columns' | translate }}</span>
        <bz-button variant="tertiary" tone="primary" size="fit"
                   appBringozIdGenerator="timekeeping-settings-columns-expand-button"
                   [ariaLabel]="(isColumnsOpen() ? 'Collapse' : 'Expand') | translate"
                   (clicked)="onToggleColumnsOpen()">
          <bz-icon [icon]="isColumnsOpen() ? icons.expanded : icons.collapsed"></bz-icon>
        </bz-button>
      </div>

      @if (isColumnsOpen()) {
        <div class="columns-container layout-row layout-wrap fade-element-in">
          @for (row of rows(); track row.key) {
            <div class="column-item">
              @if (row.permission) {
                <ng-container *ngxPermissionsOnly="row.permission">
                  <ng-container *ngTemplateOutlet="columnSwitch; context: {$implicit: row}"></ng-container>
                </ng-container>
              } @else {
                <ng-container *ngTemplateOutlet="columnSwitch; context: {$implicit: row}"></ng-container>
              }
            </div>
          }
        </div>
      }
    </section>

  </div>

  <bz-divider></bz-divider>

  <div class="layout-row layout-align-start-center padding-5">
    <bz-button variant="tertiary"
               tone="primary"
               appBringozIdGenerator="timekeeping-settings-cancel-button"
               (clicked)="onCancel()">
      <span>{{ 'Cancel' | translate }}</span>
    </bz-button>

    <span class="flex"></span>

    <bz-button variant="outline"
               tone="primary"
               class="margin-right-5"
               appBringozIdGenerator="timekeeping-settings-reset-button"
               (clicked)="onReset()">
      <span>{{ 'Reset' | translate }}</span>
    </bz-button>

    <bz-button tone="secondary"
               appBringozIdGenerator="timekeeping-settings-submit-button"
               (clicked)="onSubmit()">
      <span>{{ 'Submit' | translate }}</span>
    </bz-button>
  </div>

</div>

<ng-template #columnSwitch let-row>
  <bz-switch size="sm"
             appBringozIdGenerator="timekeeping-settings-column-switch"
             [checked]="row.enabled"
             (checkedChange)="onToggleColumn(row, $event)">
    {{ row.labelKey | translate }}
  </bz-switch>
</ng-template>
